import React, { useState, useEffect } from 'react';

const MouseTracker = ({ country, flag, ips }) => {
    const [position, setPosition] = useState({ x: 0, y: 0 });

    useEffect(() => {
        const handleMouseMove = (event) => {
            setPosition({ x: event.clientX, y: event.clientY });
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return (
        <div className='location-map-marker' style={{ position: 'fixed', top: position.y, left: position.x, pointerEvents: 'none' }}>
            <div className='location-map-marker__image'>
                <img src={flag} alt={country} />
            </div>
            <div className='location-map-marker__body'>
                <div className='button-text'>{country}</div>
                <div className='body2'>{ips}</div>
            </div>
        </div>
    );
};

export default MouseTracker;
